import {
  AbstractControl, NG_VALIDATORS, ValidationErrors, Validator,
} from '@angular/forms';
import {
  Directive, forwardRef, Input, OnChanges,
} from '@angular/core';

/** Provides the required no-op callback before Angular registers a validator change handler. */
const noopValidatorChange = (): void => {};

/** Validates that a control's value matches the value supplied by `bulbValidationFieldMatch`. */
@Directive({
  selector: 'aero-input[bulbValidationFieldMatch]',
  standalone: false,
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => AccountValidationFieldMatchDirective),
    multi: true,
  }],
})
export class AccountValidationFieldMatchDirective implements Validator, OnChanges {
  @Input() bulbValidationFieldMatch: any;

  private onValidatorChange = noopValidatorChange;

  /** Compares the control value with the configured matching value.
   * @param control Control being validated.
   * @returns No error when values match; otherwise, a `fieldMatch` validation error.
   */
  validate(control: AbstractControl): ValidationErrors | null {
    return control.value === this.bulbValidationFieldMatch ? null : { fieldMatch: true };
  }

  /** Stores Angular's callback for revalidating when the matching value changes.
   * @param fn Callback Angular invokes to rerun validation.
   */
  registerOnValidatorChange(fn: () => void): void {
    this.onValidatorChange = fn;
  }

  /** Notifies Angular that the configured matching value has changed. */
  ngOnChanges(): void {
    this.onValidatorChange();
  }
}
